// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `ArrayValue`.
export const ArrayValue = __t.enum("ArrayValue", {
  Boolean: __t.array(__t.bool()),
  Byte: __t.array(__t.i8()),
  get Bytes() {
    return __t.array(BytesWrapper);
  },
  Date: __t.array(__t.timestamp()),
  DateTime: __t.array(__t.timestamp()),
  Decimal: __t.array(__t.string()),
  Double: __t.array(__t.f64()),
  Duration: __t.array(__t.timeDuration()),
  Float: __t.array(__t.f32()),
  Integer: __t.array(__t.i32()),
  Long: __t.array(__t.i64()),
  Short: __t.array(__t.i16()),
  String: __t.array(__t.string()),
  Time: __t.array(__t.timestamp()),
  UnsignedByte: __t.byteArray(),
  UnsignedInteger: __t.array(__t.u32()),
  UnsignedLong: __t.array(__t.u64()),
  UnsignedShort: __t.array(__t.u16()),
  Uuid: __t.array(__t.string()),
});
export type ArrayValue = __Infer<typeof ArrayValue>;

// The tagged union or sum type for the algebraic type `BackgroundLayerKind`.
export const BackgroundLayerKind = __t.enum("BackgroundLayerKind", {
  Imagery: __t.unit(),
  Terrain: __t.unit(),
  Tiles3D: __t.unit(),
  GoogleP3Dt: __t.unit(),
});
export type BackgroundLayerKind = __Infer<typeof BackgroundLayerKind>;

export const BoxVolume = __t.object("BoxVolume", {
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  halfX: __t.f64(),
  halfY: __t.f64(),
  halfZ: __t.f64(),
  yawDeg: __t.f64(),
  pitchDeg: __t.f64(),
  rollDeg: __t.f64(),
});
export type BoxVolume = __Infer<typeof BoxVolume>;

export const BytesWrapper = __t.object("BytesWrapper", {
  data: __t.byteArray(),
});
export type BytesWrapper = __Infer<typeof BytesWrapper>;

// The tagged union or sum type for the algebraic type `CascadeDirection`.
export const CascadeDirection = __t.enum("CascadeDirection", {
  All: __t.unit(),
  Outgoing: __t.unit(),
  Incoming: __t.unit(),
});
export type CascadeDirection = __Infer<typeof CascadeDirection>;

// The tagged union or sum type for the algebraic type `CascadeEffect`.
export const CascadeEffect = __t.enum("CascadeEffect", {
  Transparent: __t.unit(),
  Highlight: __t.unit(),
  Hide: __t.unit(),
  Wireframe: __t.unit(),
});
export type CascadeEffect = __Infer<typeof CascadeEffect>;

// The tagged union or sum type for the algebraic type `CascadeTrigger`.
export const CascadeTrigger = __t.enum("CascadeTrigger", {
  Highlight: __t.unit(),
  Select: __t.unit(),
});
export type CascadeTrigger = __Infer<typeof CascadeTrigger>;

export const ComplexProperty = __t.object("ComplexProperty", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  name: __t.string(),
  get value() {
    return ComplexValue;
  },
});
export type ComplexProperty = __Infer<typeof ComplexProperty>;

// The tagged union or sum type for the algebraic type `ComplexValue`.
export const ComplexValue = __t.enum("ComplexValue", {
  get Array() {
    return ArrayValue;
  },
  get Enum() {
    return EnumValue;
  },
  get Map() {
    return MapValue;
  },
  get Object() {
    return ObjectValue;
  },
  get Geospatial() {
    return GeospatialValue;
  },
  get ScaledDecimal() {
    return ScaledDecimalValue;
  },
});
export type ComplexValue = __Infer<typeof ComplexValue>;

export const ConnectedClient = __t.object("ConnectedClient", {
  connectionId: __t.connectionId(),
  identity: __t.identity(),
});
export type ConnectedClient = __Infer<typeof ConnectedClient>;

// The tagged union or sum type for the algebraic type `ContentType`.
export const ContentType = __t.enum("ContentType", {
  Property: __t.unit(),
  Telemetry: __t.unit(),
  Component: __t.unit(),
  Relationship: __t.unit(),
});
export type ContentType = __Infer<typeof ContentType>;

export const ControlPointSpec = __t.object("ControlPointSpec", {
  name: __t.string(),
  gridE: __t.f64(),
  gridN: __t.f64(),
  gridElev: __t.f64(),
  groundE: __t.f64(),
  groundN: __t.f64(),
  groundElev: __t.f64(),
  lat: __t.f64(),
  lon: __t.f64(),
  elevM: __t.f64(),
  datumLabel: __t.string(),
});
export type ControlPointSpec = __Infer<typeof ControlPointSpec>;

export const CoreTablesAsOf = __t.object("CoreTablesAsOf", {
  asOfMicros: __t.i64(),
  get digitalTwin() {
    return __t.array(DigitalTwin);
  },
  get twinRelationshipInstance() {
    return __t.array(TwinRelationshipInstance);
  },
  get dtdlInterface() {
    return __t.array(DtdlInterface);
  },
  get dtdlRelationship() {
    return __t.array(DtdlRelationship);
  },
  get turbotwinMetadata() {
    return __t.array(TurboTwinMetadata);
  },
  get twinPosition() {
    return __t.array(TwinPosition);
  },
  get dtdlProperty() {
    return __t.array(DtdlProperty);
  },
  get dtdlComponent() {
    return __t.array(DtdlComponent);
  },
  get dtdlTelemetry() {
    return __t.array(DtdlTelemetry);
  },
  get twinProperty() {
    return __t.array(TwinProperty);
  },
  get twinTelemetryLink() {
    return __t.array(TwinTelemetryLink);
  },
  get complexProperty() {
    return __t.array(ComplexProperty);
  },
  get primitivePropertyBool() {
    return __t.array(PrimitivePropertyBool);
  },
  get primitivePropertyString() {
    return __t.array(PrimitivePropertyString);
  },
  get primitivePropertyByte() {
    return __t.array(PrimitivePropertyByte);
  },
  get primitivePropertyBytes() {
    return __t.array(PrimitivePropertyBytes);
  },
  get primitivePropertyDate() {
    return __t.array(PrimitivePropertyDate);
  },
  get primitivePropertyDateTime() {
    return __t.array(PrimitivePropertyDateTime);
  },
  get primitivePropertyDecimal() {
    return __t.array(PrimitivePropertyDecimal);
  },
  get primitivePropertyDouble() {
    return __t.array(PrimitivePropertyDouble);
  },
  get primitivePropertyDuration() {
    return __t.array(PrimitivePropertyDuration);
  },
  get primitivePropertyFloat() {
    return __t.array(PrimitivePropertyFloat);
  },
  get primitivePropertyInteger() {
    return __t.array(PrimitivePropertyInteger);
  },
  get primitivePropertyLong() {
    return __t.array(PrimitivePropertyLong);
  },
  get primitivePropertyShort() {
    return __t.array(PrimitivePropertyShort);
  },
  get primitivePropertyTime() {
    return __t.array(PrimitivePropertyTime);
  },
  get primitivePropertyUnsignedByte() {
    return __t.array(PrimitivePropertyUnsignedByte);
  },
  get primitivePropertyUnsignedInteger() {
    return __t.array(PrimitivePropertyUnsignedInteger);
  },
  get primitivePropertyUnsignedLong() {
    return __t.array(PrimitivePropertyUnsignedLong);
  },
  get primitivePropertyUnsignedShort() {
    return __t.array(PrimitivePropertyUnsignedShort);
  },
  get primitivePropertyUuid() {
    return __t.array(PrimitivePropertyUuid);
  },
});
export type CoreTablesAsOf = __Infer<typeof CoreTablesAsOf>;

export const DigitalTwin = __t.object("DigitalTwin", {
  twinId: __t.string(),
  dtmi: __t.string(),
  createdDateTime: __t.timestamp(),
});
export type DigitalTwin = __Infer<typeof DigitalTwin>;

export const DigitalTwinData = __t.object("DigitalTwinData", {
  twinId: __t.string(),
  dtmi: __t.string(),
});
export type DigitalTwinData = __Infer<typeof DigitalTwinData>;

export const DigitalTwinOrphaned = __t.object("DigitalTwinOrphaned", {
  twinId: __t.string(),
  dtmi: __t.string(),
  createdDateTime: __t.timestamp(),
});
export type DigitalTwinOrphaned = __Infer<typeof DigitalTwinOrphaned>;

export const DtdlComponent = __t.object("DtdlComponent", {
  id: __t.u64(),
  parentDtmi: __t.string(),
  name: __t.string(),
  schemaDtmi: __t.string(),
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlComponent = __Infer<typeof DtdlComponent>;

export const DtdlComponentData = __t.object("DtdlComponentData", {
  name: __t.string(),
  schemaDtmi: __t.string(),
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlComponentData = __Infer<typeof DtdlComponentData>;

export const DtdlExtends = __t.object("DtdlExtends", {
  id: __t.u64(),
  childDtmi: __t.string(),
  parentDtmi: __t.string(),
});
export type DtdlExtends = __Infer<typeof DtdlExtends>;

export const DtdlInheritanceChain = __t.object("DtdlInheritanceChain", {
  id: __t.u64(),
  childDtmi: __t.string(),
  ancestorDtmi: __t.string(),
  childAncestorKey: __t.string(),
  depth: __t.u32(),
});
export type DtdlInheritanceChain = __Infer<typeof DtdlInheritanceChain>;

export const DtdlInterface = __t.object("DtdlInterface", {
  dtmi: __t.string(),
  get displayName() {
    return LocalizableString;
  },
  context: __t.string(),
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlInterface = __Infer<typeof DtdlInterface>;

export const DtdlInterfaceData = __t.object("DtdlInterfaceData", {
  dtmi: __t.string(),
  get displayName() {
    return LocalizableString;
  },
  extendsDtmis: __t.array(__t.string()),
  context: __t.string(),
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlInterfaceData = __Infer<typeof DtdlInterfaceData>;

export const DtdlModel = __t.object("DtdlModel", {
  get interface() {
    return DtdlInterfaceData;
  },
  get properties() {
    return __t.array(DtdlPropertyData);
  },
  get telemetries() {
    return __t.array(DtdlTelemetryData);
  },
  get components() {
    return __t.array(DtdlComponentData);
  },
  get relationships() {
    return __t.array(DtdlRelationshipData);
  },
  get visualAsset() {
    return __t.option(VisualAssetData);
  },
  get ueClass() {
    return __t.option(UeClassData);
  },
});
export type DtdlModel = __Infer<typeof DtdlModel>;

export const DtdlProperty = __t.object("DtdlProperty", {
  id: __t.u64(),
  parentDtmi: __t.string(),
  name: __t.string(),
  get schema() {
    return SchemaValue;
  },
  writable: __t.bool(),
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
  parentRelationshipId: __t.option(__t.u64()),
});
export type DtdlProperty = __Infer<typeof DtdlProperty>;

export const DtdlPropertyData = __t.object("DtdlPropertyData", {
  name: __t.string(),
  get schema() {
    return SchemaValue;
  },
  writable: __t.bool(),
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlPropertyData = __Infer<typeof DtdlPropertyData>;

export const DtdlRelationship = __t.object("DtdlRelationship", {
  id: __t.u64(),
  parentDtmi: __t.string(),
  name: __t.string(),
  targetDtmi: __t.string(),
  writable: __t.bool(),
  get displayName() {
    return LocalizableString;
  },
  maxMultiplicity: __t.i32(),
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlRelationship = __Infer<typeof DtdlRelationship>;

export const DtdlRelationshipData = __t.object("DtdlRelationshipData", {
  name: __t.string(),
  targetDtmi: __t.string(),
  writable: __t.bool(),
  maxMultiplicity: __t.i32(),
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
  get properties() {
    return __t.array(DtdlPropertyData);
  },
});
export type DtdlRelationshipData = __Infer<typeof DtdlRelationshipData>;

export const DtdlTelemetry = __t.object("DtdlTelemetry", {
  id: __t.u64(),
  parentDtmi: __t.string(),
  name: __t.string(),
  get schema() {
    return SchemaValue;
  },
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlTelemetry = __Infer<typeof DtdlTelemetry>;

export const DtdlTelemetryData = __t.object("DtdlTelemetryData", {
  name: __t.string(),
  get schema() {
    return SchemaValue;
  },
  get displayName() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
export type DtdlTelemetryData = __Infer<typeof DtdlTelemetryData>;

export const DuplicateTwinOptions = __t.object("DuplicateTwinOptions", {
  duplicateOutboundRelationships: __t.bool(),
  duplicateInboundRelationships: __t.bool(),
  duplicatePropertyValues: __t.bool(),
  duplicateMetadata: __t.bool(),
});
export type DuplicateTwinOptions = __Infer<typeof DuplicateTwinOptions>;

export const EditFieldChange = __t.object("EditFieldChange", {
  table: __t.string(),
  label: __t.string(),
  field: __t.string(),
  before: __t.string(),
  after: __t.string(),
});
export type EditFieldChange = __Infer<typeof EditFieldChange>;

export const EditJournal = __t.object("EditJournal", {
  editId: __t.u64(),
  actor: __t.identity(),
  actorLabel: __t.string(),
  at: __t.timestamp(),
  get kind() {
    return EditKind;
  },
  targetKind: __t.string(),
  targetIds: __t.array(__t.string()),
  summary: __t.string(),
  undoneBy: __t.option(__t.u64()),
  sessionId: __t.option(__t.string()),
  targetDetail: __t.option(__t.string()),
  editGroup: __t.option(__t.string()),
});
export type EditJournal = __Infer<typeof EditJournal>;

export const EditJournalCounter = __t.object("EditJournalCounter", {
  key: __t.u32(),
  nextEditId: __t.u64(),
  trimmedBelow: __t.u64(),
});
export type EditJournalCounter = __Infer<typeof EditJournalCounter>;

export const EditJournalDrainSchedule = __t.object("EditJournalDrainSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type EditJournalDrainSchedule = __Infer<typeof EditJournalDrainSchedule>;

// The tagged union or sum type for the algebraic type `EditKind`.
export const EditKind = __t.enum("EditKind", {
  TwinMoved: __t.unit(),
  TwinRotated: __t.unit(),
  TwinCreated: __t.unit(),
  TwinDeleted: __t.unit(),
  PropertyChanged: __t.unit(),
  GeometryDrawn: __t.unit(),
  RelationshipChanged: __t.unit(),
  ModelChanged: __t.unit(),
  BulkImport: __t.unit(),
  Undo: __t.unit(),
  AssetBindingChanged: __t.unit(),
  TelemetryLinkChanged: __t.unit(),
  ProjectSettingChanged: __t.unit(),
  MaintenanceOperation: __t.unit(),
});
export type EditKind = __Infer<typeof EditKind>;

export const EditProvenance = __t.object("EditProvenance", {
  connectionId: __t.connectionId(),
  provenance: __t.string(),
  setBy: __t.identity(),
  at: __t.timestamp(),
});
export type EditProvenance = __Infer<typeof EditProvenance>;

export const EnumIntegerValue = __t.object("EnumIntegerValue", {
  name: __t.string(),
  value: __t.i32(),
});
export type EnumIntegerValue = __Infer<typeof EnumIntegerValue>;

export const EnumStringValue = __t.object("EnumStringValue", {
  name: __t.string(),
  value: __t.string(),
});
export type EnumStringValue = __Infer<typeof EnumStringValue>;

// The tagged union or sum type for the algebraic type `EnumValue`.
export const EnumValue = __t.enum("EnumValue", {
  get String() {
    return EnumStringValue;
  },
  get Integer() {
    return EnumIntegerValue;
  },
});
export type EnumValue = __Infer<typeof EnumValue>;

// The tagged union or sum type for the algebraic type `EnumValueSchemaType`.
export const EnumValueSchemaType = __t.enum("EnumValueSchemaType", {
  String: __t.unit(),
  Integer: __t.unit(),
});
export type EnumValueSchemaType = __Infer<typeof EnumValueSchemaType>;

// The tagged union or sum type for the algebraic type `EnumValues`.
export const EnumValues = __t.enum("EnumValues", {
  get Integer() {
    return __t.array(IntegerEnumValue);
  },
  get String() {
    return __t.array(StringEnumValue);
  },
});
export type EnumValues = __Infer<typeof EnumValues>;

// The tagged union or sum type for the algebraic type `ExportKind`.
export const ExportKind = __t.enum("ExportKind", {
  Model: __t.unit(),
  Twin: __t.unit(),
  Relationship: __t.unit(),
  Graph: __t.unit(),
  TelemetryLinksForComponent: __t.unit(),
});
export type ExportKind = __Infer<typeof ExportKind>;

export const ExportResultEvent = __t.object("ExportResultEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get kind() {
    return ExportKind;
  },
  success: __t.bool(),
  payload: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type ExportResultEvent = __Infer<typeof ExportResultEvent>;

export const GeoCoordinates = __t.object("GeoCoordinates", {
  get positions() {
    return __t.array(GeoPosition);
  },
});
export type GeoCoordinates = __Infer<typeof GeoCoordinates>;

export const GeoLineString = __t.object("GeoLineString", {
  get coordinates() {
    return __t.array(GeoPosition);
  },
});
export type GeoLineString = __Infer<typeof GeoLineString>;

export const GeoMultiLineString = __t.object("GeoMultiLineString", {
  get lineStrings() {
    return __t.array(GeoCoordinates);
  },
});
export type GeoMultiLineString = __Infer<typeof GeoMultiLineString>;

export const GeoMultiPoint = __t.object("GeoMultiPoint", {
  get coordinates() {
    return __t.array(GeoPosition);
  },
});
export type GeoMultiPoint = __Infer<typeof GeoMultiPoint>;

export const GeoMultiPolygon = __t.object("GeoMultiPolygon", {
  get polygons() {
    return __t.array(GeoPolygon);
  },
});
export type GeoMultiPolygon = __Infer<typeof GeoMultiPolygon>;

export const GeoPoint = __t.object("GeoPoint", {
  get coordinates() {
    return GeoPosition;
  },
});
export type GeoPoint = __Infer<typeof GeoPoint>;

export const GeoPolygon = __t.object("GeoPolygon", {
  get rings() {
    return __t.array(GeoCoordinates);
  },
});
export type GeoPolygon = __Infer<typeof GeoPolygon>;

export const GeoPosition = __t.object("GeoPosition", {
  longitude: __t.f64(),
  latitude: __t.f64(),
  altitude: __t.option(__t.f64()),
});
export type GeoPosition = __Infer<typeof GeoPosition>;

// The tagged union or sum type for the algebraic type `GeometryBindingKind`.
export const GeometryBindingKind = __t.enum("GeometryBindingKind", {
  NodePath: __t.string(),
  get Sphere() {
    return SphereVolume;
  },
  get Box() {
    return BoxVolume;
  },
  NameMatch: __t.string(),
});
export type GeometryBindingKind = __Infer<typeof GeometryBindingKind>;

// The tagged union or sum type for the algebraic type `GeospatialSchemaType`.
export const GeospatialSchemaType = __t.enum("GeospatialSchemaType", {
  Point: __t.unit(),
  MultiPoint: __t.unit(),
  LineString: __t.unit(),
  MultiLineString: __t.unit(),
  Polygon: __t.unit(),
  MultiPolygon: __t.unit(),
});
export type GeospatialSchemaType = __Infer<typeof GeospatialSchemaType>;

// The tagged union or sum type for the algebraic type `GeospatialValue`.
export const GeospatialValue = __t.enum("GeospatialValue", {
  get Point() {
    return GeoPoint;
  },
  get MultiPoint() {
    return GeoMultiPoint;
  },
  get LineString() {
    return GeoLineString;
  },
  get MultiLineString() {
    return GeoMultiLineString;
  },
  get Polygon() {
    return GeoPolygon;
  },
  get MultiPolygon() {
    return GeoMultiPolygon;
  },
});
export type GeospatialValue = __Infer<typeof GeospatialValue>;

export const ImportDryRunResultEvent = __t.object("ImportDryRunResultEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  valid: __t.bool(),
  modelsToCreate: __t.u32(),
  modelsToUpdate: __t.u32(),
  twinsToCreate: __t.u32(),
  twinsToUpdate: __t.u32(),
  twinsToSkip: __t.u32(),
  relationshipsToCreate: __t.u32(),
  relationshipsToSkip: __t.u32(),
  errorCount: __t.u32(),
  warningCount: __t.u32(),
  reportJson: __t.string(),
  createdAt: __t.timestamp(),
});
export type ImportDryRunResultEvent = __Infer<typeof ImportDryRunResultEvent>;

export const ImportMappingProgressEvent = __t.object("ImportMappingProgressEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get stage() {
    return ImportMappingProgressStage;
  },
  createdAt: __t.timestamp(),
});
export type ImportMappingProgressEvent = __Infer<typeof ImportMappingProgressEvent>;

// The tagged union or sum type for the algebraic type `ImportMappingProgressStage`.
export const ImportMappingProgressStage = __t.enum("ImportMappingProgressStage", {
  Received: __t.unit(),
  Thinking: __t.unit(),
  Repairing: __t.unit(),
  Delivering: __t.unit(),
  DeliveryFailed: __t.unit(),
  NoWriteAccess: __t.unit(),
});
export type ImportMappingProgressStage = __Infer<typeof ImportMappingProgressStage>;

export const ImportMappingRequestEvent = __t.object("ImportMappingRequestEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get kind() {
    return ImportMappingRequestKind;
  },
  profileJson: __t.string(),
  currentSpecJson: __t.string(),
  instruction: __t.string(),
  createdAt: __t.timestamp(),
});
export type ImportMappingRequestEvent = __Infer<typeof ImportMappingRequestEvent>;

// The tagged union or sum type for the algebraic type `ImportMappingRequestKind`.
export const ImportMappingRequestKind = __t.enum("ImportMappingRequestKind", {
  Propose: __t.unit(),
  Patch: __t.unit(),
});
export type ImportMappingRequestKind = __Infer<typeof ImportMappingRequestKind>;

export const ImportMappingResultEvent = __t.object("ImportMappingResultEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  success: __t.bool(),
  specJson: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type ImportMappingResultEvent = __Infer<typeof ImportMappingResultEvent>;

// The tagged union or sum type for the algebraic type `ImportModeConflict`.
export const ImportModeConflict = __t.enum("ImportModeConflict", {
  SkipExisting: __t.unit(),
  UpdateExisting: __t.unit(),
  FailOnConflict: __t.unit(),
});
export type ImportModeConflict = __Infer<typeof ImportModeConflict>;

// The tagged union or sum type for the algebraic type `ImportModeSystemConfig`.
export const ImportModeSystemConfig = __t.enum("ImportModeSystemConfig", {
  SkipExisting: __t.unit(),
  UpdateExisting: __t.unit(),
  ReplaceAll: __t.unit(),
});
export type ImportModeSystemConfig = __Infer<typeof ImportModeSystemConfig>;

export const ImportRun = __t.object("ImportRun", {
  id: __t.u64(),
  runId: __t.string(),
  sourceName: __t.string(),
  fingerprint: __t.string(),
  specHash: __t.string(),
  startedBy: __t.identity(),
  recordedAt: __t.timestamp(),
  durationMs: __t.u32(),
  models: __t.u32(),
  twinsCreated: __t.u32(),
  twinsUpdated: __t.u32(),
  relationships: __t.u32(),
  status: __t.string(),
  createdIdsJson: __t.string(),
  createdIdsTruncated: __t.bool(),
  undoDeleted: __t.u32(),
  undoSkipped: __t.u32(),
});
export type ImportRun = __Infer<typeof ImportRun>;

export const ImportTemplate = __t.object("ImportTemplate", {
  id: __t.u64(),
  name: __t.string(),
  fingerprint: __t.string(),
  specJson: __t.string(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ImportTemplate = __Infer<typeof ImportTemplate>;

export const ImportUndoBatchSchedule = __t.object("ImportUndoBatchSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  runId: __t.string(),
  cursor: __t.u32(),
});
export type ImportUndoBatchSchedule = __Infer<typeof ImportUndoBatchSchedule>;

export const ImportWarning = __t.object("ImportWarning", {
  kind: __t.string(),
  twinId: __t.option(__t.string()),
  modelDtmi: __t.option(__t.string()),
  componentName: __t.option(__t.string()),
  telemetryName: __t.option(__t.string()),
  streamName: __t.option(__t.string()),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type ImportWarning = __Infer<typeof ImportWarning>;

export const IntegerEnumValue = __t.object("IntegerEnumValue", {
  name: __t.string(),
  value: __t.i32(),
});
export type IntegerEnumValue = __Infer<typeof IntegerEnumValue>;

export const JournalHistoryPage = __t.object("JournalHistoryPage", {
  get rows() {
    return __t.array(EditJournal);
  },
  total: __t.u32(),
  nextOffset: __t.option(__t.u32()),
  historyFloor: __t.option(__t.timestamp()),
});
export type JournalHistoryPage = __Infer<typeof JournalHistoryPage>;

export const LocalizableString = __t.object("LocalizableString", {
  get entries() {
    return __t.array(StringMap);
  },
});
export type LocalizableString = __Infer<typeof LocalizableString>;

// The tagged union or sum type for the algebraic type `LocationMode`.
export const LocationMode = __t.enum("LocationMode", {
  Static: __t.unit(),
  Dynamic: __t.unit(),
  None: __t.unit(),
});
export type LocationMode = __Infer<typeof LocationMode>;

// The tagged union or sum type for the algebraic type `MapValue`.
export const MapValue = __t.enum("MapValue", {
  get Boolean() {
    return __t.array(StringBooleanPair);
  },
  get Byte() {
    return __t.array(StringBytePair);
  },
  get Bytes() {
    return __t.array(StringBytesPair);
  },
  get Date() {
    return __t.array(StringDatePair);
  },
  get DateTime() {
    return __t.array(StringDateTimePair);
  },
  get Decimal() {
    return __t.array(StringDecimalPair);
  },
  get Double() {
    return __t.array(StringDoublePair);
  },
  get Duration() {
    return __t.array(StringDurationPair);
  },
  get Float() {
    return __t.array(StringFloatPair);
  },
  get Integer() {
    return __t.array(StringIntegerPair);
  },
  get Long() {
    return __t.array(StringLongPair);
  },
  get Short() {
    return __t.array(StringShortPair);
  },
  get String() {
    return __t.array(StringStringPair);
  },
  get Time() {
    return __t.array(StringTimePair);
  },
  get UnsignedByte() {
    return __t.array(StringUnsignedBytePair);
  },
  get UnsignedInteger() {
    return __t.array(StringUnsignedIntegerPair);
  },
  get UnsignedLong() {
    return __t.array(StringUnsignedLongPair);
  },
  get UnsignedShort() {
    return __t.array(StringUnsignedShortPair);
  },
  get Uuid() {
    return __t.array(StringUuidPair);
  },
});
export type MapValue = __Infer<typeof MapValue>;

export const ModelAssetBinding = __t.object("ModelAssetBinding", {
  dtmi: __t.string(),
  assetPath: __t.string(),
  get assetSource() {
    return VisualAssetSource;
  },
  assetModuleAssetId: __t.option(__t.u64()),
});
export type ModelAssetBinding = __Infer<typeof ModelAssetBinding>;

export const ModelDofLink = __t.object("ModelDofLink", {
  linkId: __t.u64(),
  dtmi: __t.string(),
  dofName: __t.string(),
  sourceKind: __t.string(),
  sourceName: __t.string(),
  constantValue: __t.f64(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
  transitionSeconds: __t.f64(),
  idleTimeoutSeconds: __t.f64(),
});
export type ModelDofLink = __Infer<typeof ModelDofLink>;

export const ModelUeClass = __t.object("ModelUeClass", {
  dtmi: __t.string(),
  classPath: __t.string(),
});
export type ModelUeClass = __Infer<typeof ModelUeClass>;

// The tagged union or sum type for the algebraic type `ModelVersionStatus`.
export const ModelVersionStatus = __t.enum("ModelVersionStatus", {
  Draft: __t.unit(),
  Active: __t.unit(),
  Deprecated: __t.unit(),
});
export type ModelVersionStatus = __Infer<typeof ModelVersionStatus>;

export const ModelVersions = __t.object("ModelVersions", {
  versionId: __t.u64(),
  dtmi: __t.string(),
  version: __t.string(),
  get status() {
    return ModelVersionStatus;
  },
  createdDateTime: __t.timestamp(),
});
export type ModelVersions = __Infer<typeof ModelVersions>;

// The tagged union or sum type for the algebraic type `ModuleRole`.
export const ModuleRole = __t.enum("ModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type ModuleRole = __Infer<typeof ModuleRole>;

export const ModuleServiceConfig = __t.object("ModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type ModuleServiceConfig = __Infer<typeof ModuleServiceConfig>;

export const ModuleUser = __t.object("ModuleUser", {
  identity: __t.identity(),
  get role() {
    return ModuleRole;
  },
});
export type ModuleUser = __Infer<typeof ModuleUser>;

export const ObjectField = __t.object("ObjectField", {
  name: __t.string(),
  get value() {
    return PrimitiveValue;
  },
});
export type ObjectField = __Infer<typeof ObjectField>;

export const ObjectValue = __t.object("ObjectValue", {
  get fields() {
    return __t.array(ObjectField);
  },
});
export type ObjectValue = __Infer<typeof ObjectValue>;

export const PrimitivePropertyBool = __t.object("PrimitivePropertyBool", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.bool(),
});
export type PrimitivePropertyBool = __Infer<typeof PrimitivePropertyBool>;

export const PrimitivePropertyByte = __t.object("PrimitivePropertyByte", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.i8(),
});
export type PrimitivePropertyByte = __Infer<typeof PrimitivePropertyByte>;

export const PrimitivePropertyBytes = __t.object("PrimitivePropertyBytes", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.byteArray(),
});
export type PrimitivePropertyBytes = __Infer<typeof PrimitivePropertyBytes>;

export const PrimitivePropertyDate = __t.object("PrimitivePropertyDate", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.timestamp(),
});
export type PrimitivePropertyDate = __Infer<typeof PrimitivePropertyDate>;

export const PrimitivePropertyDateTime = __t.object("PrimitivePropertyDateTime", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.timestamp(),
});
export type PrimitivePropertyDateTime = __Infer<typeof PrimitivePropertyDateTime>;

export const PrimitivePropertyDecimal = __t.object("PrimitivePropertyDecimal", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.string(),
});
export type PrimitivePropertyDecimal = __Infer<typeof PrimitivePropertyDecimal>;

export const PrimitivePropertyDouble = __t.object("PrimitivePropertyDouble", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.f64(),
});
export type PrimitivePropertyDouble = __Infer<typeof PrimitivePropertyDouble>;

export const PrimitivePropertyDuration = __t.object("PrimitivePropertyDuration", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.timeDuration(),
});
export type PrimitivePropertyDuration = __Infer<typeof PrimitivePropertyDuration>;

export const PrimitivePropertyFloat = __t.object("PrimitivePropertyFloat", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.f32(),
});
export type PrimitivePropertyFloat = __Infer<typeof PrimitivePropertyFloat>;

export const PrimitivePropertyInteger = __t.object("PrimitivePropertyInteger", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.i32(),
});
export type PrimitivePropertyInteger = __Infer<typeof PrimitivePropertyInteger>;

export const PrimitivePropertyLong = __t.object("PrimitivePropertyLong", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.i64(),
});
export type PrimitivePropertyLong = __Infer<typeof PrimitivePropertyLong>;

export const PrimitivePropertyShort = __t.object("PrimitivePropertyShort", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.i16(),
});
export type PrimitivePropertyShort = __Infer<typeof PrimitivePropertyShort>;

export const PrimitivePropertyString = __t.object("PrimitivePropertyString", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.string(),
});
export type PrimitivePropertyString = __Infer<typeof PrimitivePropertyString>;

export const PrimitivePropertyTime = __t.object("PrimitivePropertyTime", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.timestamp(),
});
export type PrimitivePropertyTime = __Infer<typeof PrimitivePropertyTime>;

export const PrimitivePropertyUnsignedByte = __t.object("PrimitivePropertyUnsignedByte", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.u8(),
});
export type PrimitivePropertyUnsignedByte = __Infer<typeof PrimitivePropertyUnsignedByte>;

export const PrimitivePropertyUnsignedInteger = __t.object("PrimitivePropertyUnsignedInteger", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.u32(),
});
export type PrimitivePropertyUnsignedInteger = __Infer<typeof PrimitivePropertyUnsignedInteger>;

export const PrimitivePropertyUnsignedLong = __t.object("PrimitivePropertyUnsignedLong", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.u64(),
});
export type PrimitivePropertyUnsignedLong = __Infer<typeof PrimitivePropertyUnsignedLong>;

export const PrimitivePropertyUnsignedShort = __t.object("PrimitivePropertyUnsignedShort", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.u16(),
});
export type PrimitivePropertyUnsignedShort = __Infer<typeof PrimitivePropertyUnsignedShort>;

export const PrimitivePropertyUuid = __t.object("PrimitivePropertyUuid", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  value: __t.string(),
});
export type PrimitivePropertyUuid = __Infer<typeof PrimitivePropertyUuid>;

// The tagged union or sum type for the algebraic type `PrimitiveSchemaType`.
export const PrimitiveSchemaType = __t.enum("PrimitiveSchemaType", {
  Boolean: __t.unit(),
  Byte: __t.unit(),
  Bytes: __t.unit(),
  Date: __t.unit(),
  DateTime: __t.unit(),
  Decimal: __t.unit(),
  Double: __t.unit(),
  Duration: __t.unit(),
  Float: __t.unit(),
  Integer: __t.unit(),
  Long: __t.unit(),
  Short: __t.unit(),
  String: __t.unit(),
  Time: __t.unit(),
  UnsignedByte: __t.unit(),
  UnsignedInteger: __t.unit(),
  UnsignedLong: __t.unit(),
  UnsignedShort: __t.unit(),
  Uuid: __t.unit(),
});
export type PrimitiveSchemaType = __Infer<typeof PrimitiveSchemaType>;

// The tagged union or sum type for the algebraic type `PrimitiveValue`.
export const PrimitiveValue = __t.enum("PrimitiveValue", {
  Boolean: __t.bool(),
  Byte: __t.i8(),
  Bytes: __t.byteArray(),
  Date: __t.timestamp(),
  DateTime: __t.timestamp(),
  Decimal: __t.string(),
  Double: __t.f64(),
  Duration: __t.timeDuration(),
  Float: __t.f32(),
  Integer: __t.i32(),
  Long: __t.i64(),
  Short: __t.i16(),
  String: __t.string(),
  Time: __t.timestamp(),
  UnsignedByte: __t.u8(),
  UnsignedInteger: __t.u32(),
  UnsignedLong: __t.u64(),
  UnsignedShort: __t.u16(),
  Uuid: __t.string(),
});
export type PrimitiveValue = __Infer<typeof PrimitiveValue>;

export const ProjectBackgroundLayer = __t.object("ProjectBackgroundLayer", {
  selectionId: __t.u64(),
  catalogRef: __t.string(),
  get kind() {
    return BackgroundLayerKind;
  },
  name: __t.string(),
  sourceUrl: __t.string(),
  attribution: __t.string(),
  dailyRequestCap: __t.u32(),
  maxZoom: __t.u32(),
  enabled: __t.bool(),
  opacity: __t.f32(),
  layerOrder: __t.i32(),
});
export type ProjectBackgroundLayer = __Infer<typeof ProjectBackgroundLayer>;

export const ProjectBackgroundLayerKey = __t.object("ProjectBackgroundLayerKey", {
  selectionId: __t.u64(),
  apiKey: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ProjectBackgroundLayerKey = __Infer<typeof ProjectBackgroundLayerKey>;

export const ProjectConfig = __t.object("ProjectConfig", {
  configId: __t.u32(),
  get projectLocation() {
    return ProjectLocationMode;
  },
  useFirstTwinFallback: __t.bool(),
  startupMap: __t.option(__t.string()),
});
export type ProjectConfig = __Infer<typeof ProjectConfig>;

export const ProjectControlPoint = __t.object("ProjectControlPoint", {
  pointId: __t.u64(),
  name: __t.string(),
  gridE: __t.f64(),
  gridN: __t.f64(),
  gridElev: __t.f64(),
  groundE: __t.f64(),
  groundN: __t.f64(),
  groundElev: __t.f64(),
  lat: __t.f64(),
  lon: __t.f64(),
  elevM: __t.f64(),
  datumLabel: __t.string(),
  enabled: __t.bool(),
});
export type ProjectControlPoint = __Infer<typeof ProjectControlPoint>;

// The tagged union or sum type for the algebraic type `ProjectLocationMode`.
export const ProjectLocationMode = __t.enum("ProjectLocationMode", {
  None: __t.unit(),
  get Static() {
    return StaticLocation;
  },
  get TwinReference() {
    return TwinLocationReference;
  },
});
export type ProjectLocationMode = __Infer<typeof ProjectLocationMode>;

export const ProjectScopeConfig = __t.object("ProjectScopeConfig", {
  id: __t.u32(),
  projectName: __t.string(),
  configuredAt: __t.timestamp(),
  allowedScopes: __t.option(__t.array(__t.string())),
});
export type ProjectScopeConfig = __Infer<typeof ProjectScopeConfig>;

export const ProjectSurface = __t.object("ProjectSurface", {
  surfaceId: __t.u64(),
  assetRef: __t.string(),
  name: __t.string(),
  assetId: __t.u64(),
  layerOrder: __t.i32(),
  enabled: __t.bool(),
  isGround: __t.bool(),
  clipsGround: __t.bool(),
  geoOriginLon: __t.f64(),
  geoOriginLat: __t.f64(),
  geoOriginAlt: __t.f64(),
  geoHeadingDeg: __t.f64(),
  footprintGeojson: __t.string(),
  twinId: __t.option(__t.string()),
  updatedAt: __t.timestamp(),
});
export type ProjectSurface = __Infer<typeof ProjectSurface>;

export const ProjectSurfaceClientState = __t.object("ProjectSurfaceClientState", {
  key: __t.string(),
  surfaceId: __t.u64(),
  clientType: __t.string(),
  enabled: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type ProjectSurfaceClientState = __Infer<typeof ProjectSurfaceClientState>;

export const ProjectTenantConfig = __t.object("ProjectTenantConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  isPublic: __t.bool(),
  configuredAt: __t.timestamp(),
});
export type ProjectTenantConfig = __Infer<typeof ProjectTenantConfig>;

// The tagged union or sum type for the algebraic type `PropertyValue`.
export const PropertyValue = __t.enum("PropertyValue", {
  get Primitive() {
    return PrimitiveValue;
  },
  get Complex() {
    return ComplexValue;
  },
});
export type PropertyValue = __Infer<typeof PropertyValue>;

export const RelationshipCascadeRule = __t.object("RelationshipCascadeRule", {
  ruleId: __t.u64(),
  relationshipName: __t.string(),
  triggerDtmi: __t.option(__t.string()),
  get direction() {
    return CascadeDirection;
  },
  get triggers() {
    return __t.array(CascadeTrigger);
  },
  get effect() {
    return CascadeEffect;
  },
  opacity: __t.f32(),
  useOverrideOpacity: __t.bool(),
  get overrideColor() {
    return RgbaColor;
  },
  useOverrideColor: __t.bool(),
  maxDepth: __t.i32(),
});
export type RelationshipCascadeRule = __Infer<typeof RelationshipCascadeRule>;

export const RelationshipCreationData = __t.object("RelationshipCreationData", {
  sourceTwinId: __t.string(),
  targetTwinId: __t.string(),
  relationshipName: __t.string(),
  get properties() {
    return __t.array(RelationshipPropertyValueData);
  },
});
export type RelationshipCreationData = __Infer<typeof RelationshipCreationData>;

export const RelationshipPropertyValueData = __t.object("RelationshipPropertyValueData", {
  name: __t.string(),
  get value() {
    return PropertyValue;
  },
});
export type RelationshipPropertyValueData = __Infer<typeof RelationshipPropertyValueData>;

export const RgbaColor = __t.object("RgbaColor", {
  r: __t.f32(),
  g: __t.f32(),
  b: __t.f32(),
  a: __t.f32(),
});
export type RgbaColor = __Infer<typeof RgbaColor>;

export const ScaledDecimalValue = __t.object("ScaledDecimalValue", {
  value: __t.string(),
  scale: __t.i32(),
});
export type ScaledDecimalValue = __Infer<typeof ScaledDecimalValue>;

export const SchemaEnum = __t.object("SchemaEnum", {
  get valueSchema() {
    return EnumValueSchemaType;
  },
  get enumValues() {
    return EnumValues;
  },
});
export type SchemaEnum = __Infer<typeof SchemaEnum>;

export const SchemaMap = __t.object("SchemaMap", {
  mapKeyName: __t.string(),
  mapValueName: __t.string(),
  get valueSchema() {
    return PrimitiveSchemaType;
  },
});
export type SchemaMap = __Infer<typeof SchemaMap>;

export const SchemaObject = __t.object("SchemaObject", {
  get fields() {
    return __t.array(SchemaObjectField);
  },
});
export type SchemaObject = __Infer<typeof SchemaObject>;

export const SchemaObjectField = __t.object("SchemaObjectField", {
  name: __t.string(),
  get schema() {
    return PrimitiveSchemaType;
  },
});
export type SchemaObjectField = __Infer<typeof SchemaObjectField>;

// The tagged union or sum type for the algebraic type `SchemaValue`.
export const SchemaValue = __t.enum("SchemaValue", {
  get Primitive() {
    return PrimitiveSchemaType;
  },
  get Object() {
    return SchemaObject;
  },
  get Array() {
    return PrimitiveSchemaType;
  },
  get Map() {
    return SchemaMap;
  },
  get Enum() {
    return SchemaEnum;
  },
  get Geospatial() {
    return GeospatialSchemaType;
  },
  get ScaledDecimal() {
    return Unit;
  },
});
export type SchemaValue = __Infer<typeof SchemaValue>;

export const SphereVolume = __t.object("SphereVolume", {
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  radius: __t.f64(),
});
export type SphereVolume = __Infer<typeof SphereVolume>;

export const StaticLocation = __t.object("StaticLocation", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  altitude: __t.f64(),
});
export type StaticLocation = __Infer<typeof StaticLocation>;

export const StringBooleanPair = __t.object("StringBooleanPair", {
  key: __t.string(),
  value: __t.bool(),
});
export type StringBooleanPair = __Infer<typeof StringBooleanPair>;

export const StringBytePair = __t.object("StringBytePair", {
  key: __t.string(),
  value: __t.i8(),
});
export type StringBytePair = __Infer<typeof StringBytePair>;

export const StringBytesPair = __t.object("StringBytesPair", {
  key: __t.string(),
  value: __t.byteArray(),
});
export type StringBytesPair = __Infer<typeof StringBytesPair>;

export const StringDatePair = __t.object("StringDatePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringDatePair = __Infer<typeof StringDatePair>;

export const StringDateTimePair = __t.object("StringDateTimePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringDateTimePair = __Infer<typeof StringDateTimePair>;

export const StringDecimalPair = __t.object("StringDecimalPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringDecimalPair = __Infer<typeof StringDecimalPair>;

export const StringDoublePair = __t.object("StringDoublePair", {
  key: __t.string(),
  value: __t.f64(),
});
export type StringDoublePair = __Infer<typeof StringDoublePair>;

export const StringDurationPair = __t.object("StringDurationPair", {
  key: __t.string(),
  value: __t.timeDuration(),
});
export type StringDurationPair = __Infer<typeof StringDurationPair>;

export const StringEnumValue = __t.object("StringEnumValue", {
  name: __t.string(),
  value: __t.string(),
});
export type StringEnumValue = __Infer<typeof StringEnumValue>;

export const StringFloatPair = __t.object("StringFloatPair", {
  key: __t.string(),
  value: __t.f32(),
});
export type StringFloatPair = __Infer<typeof StringFloatPair>;

export const StringIntegerPair = __t.object("StringIntegerPair", {
  key: __t.string(),
  value: __t.i32(),
});
export type StringIntegerPair = __Infer<typeof StringIntegerPair>;

export const StringLongPair = __t.object("StringLongPair", {
  key: __t.string(),
  value: __t.i64(),
});
export type StringLongPair = __Infer<typeof StringLongPair>;

export const StringMap = __t.object("StringMap", {
  key: __t.string(),
  value: __t.string(),
});
export type StringMap = __Infer<typeof StringMap>;

export const StringShortPair = __t.object("StringShortPair", {
  key: __t.string(),
  value: __t.i16(),
});
export type StringShortPair = __Infer<typeof StringShortPair>;

export const StringStringPair = __t.object("StringStringPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringStringPair = __Infer<typeof StringStringPair>;

export const StringTimePair = __t.object("StringTimePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringTimePair = __Infer<typeof StringTimePair>;

export const StringUnsignedBytePair = __t.object("StringUnsignedBytePair", {
  key: __t.string(),
  value: __t.u8(),
});
export type StringUnsignedBytePair = __Infer<typeof StringUnsignedBytePair>;

export const StringUnsignedIntegerPair = __t.object("StringUnsignedIntegerPair", {
  key: __t.string(),
  value: __t.u32(),
});
export type StringUnsignedIntegerPair = __Infer<typeof StringUnsignedIntegerPair>;

export const StringUnsignedLongPair = __t.object("StringUnsignedLongPair", {
  key: __t.string(),
  value: __t.u64(),
});
export type StringUnsignedLongPair = __Infer<typeof StringUnsignedLongPair>;

export const StringUnsignedShortPair = __t.object("StringUnsignedShortPair", {
  key: __t.string(),
  value: __t.u16(),
});
export type StringUnsignedShortPair = __Infer<typeof StringUnsignedShortPair>;

export const StringUuidPair = __t.object("StringUuidPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringUuidPair = __Infer<typeof StringUuidPair>;

export const SystemConfig = __t.object("SystemConfig", {
  configKey: __t.string(),
  configValue: __t.string(),
});
export type SystemConfig = __Infer<typeof SystemConfig>;

export const TelemetryLinkData = __t.object("TelemetryLinkData", {
  streamName: __t.string(),
  telemetryPath: __t.string(),
});
export type TelemetryLinkData = __Infer<typeof TelemetryLinkData>;

// The tagged union or sum type for the algebraic type `TemporalTableSet`.
export const TemporalTableSet = __t.enum("TemporalTableSet", {
  Graph: __t.unit(),
  Diff: __t.unit(),
  Versioned: __t.unit(),
});
export type TemporalTableSet = __Infer<typeof TemporalTableSet>;

export const TurboTwinMetadata = __t.object("TurboTwinMetadata", {
  twinId: __t.string(),
  get locationMode() {
    return LocationMode;
  },
  geoLocationLatitude: __t.option(__t.f64()),
  geoLocationLongitude: __t.option(__t.f64()),
  geoLocationElevation: __t.option(__t.f64()),
  orientationYaw: __t.option(__t.f32()),
  orientationPitch: __t.option(__t.f32()),
  orientationRoll: __t.option(__t.f32()),
  streamName: __t.option(__t.string()),
  meshSection: __t.option(__t.string()),
});
export type TurboTwinMetadata = __Infer<typeof TurboTwinMetadata>;

export const TurboTwinMetadataData = __t.object("TurboTwinMetadataData", {
  get locationMode() {
    return LocationMode;
  },
  geoLocationLatitude: __t.option(__t.f64()),
  geoLocationLongitude: __t.option(__t.f64()),
  geoLocationElevation: __t.option(__t.f64()),
  orientationYaw: __t.option(__t.f64()),
  orientationPitch: __t.option(__t.f64()),
  orientationRoll: __t.option(__t.f64()),
  streamName: __t.option(__t.string()),
});
export type TurboTwinMetadataData = __Infer<typeof TurboTwinMetadataData>;

export const TwinAssetBinding = __t.object("TwinAssetBinding", {
  twinId: __t.string(),
  assetPath: __t.string(),
  get assetSource() {
    return VisualAssetSource;
  },
  assetModuleAssetId: __t.option(__t.u64()),
});
export type TwinAssetBinding = __Infer<typeof TwinAssetBinding>;

export const TwinComponent = __t.object("TwinComponent", {
  id: __t.u64(),
  twinId: __t.string(),
  componentName: __t.string(),
  dtdlComponentId: __t.u64(),
});
export type TwinComponent = __Infer<typeof TwinComponent>;

export const TwinComponentData = __t.object("TwinComponentData", {
  componentName: __t.string(),
  dtdlComponentId: __t.u64(),
});
export type TwinComponentData = __Infer<typeof TwinComponentData>;

export const TwinCreationData = __t.object("TwinCreationData", {
  twinId: __t.string(),
  dtmi: __t.string(),
});
export type TwinCreationData = __Infer<typeof TwinCreationData>;

export const TwinDofBinding = __t.object("TwinDofBinding", {
  bindingId: __t.u64(),
  twinId: __t.string(),
  dofName: __t.string(),
  sourceKind: __t.string(),
  sourceName: __t.string(),
  constantValue: __t.f64(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
  transitionSeconds: __t.f64(),
  idleTimeoutSeconds: __t.f64(),
});
export type TwinDofBinding = __Infer<typeof TwinDofBinding>;

export const TwinDofLink = __t.object("TwinDofLink", {
  linkId: __t.u64(),
  twinId: __t.string(),
  streamName: __t.string(),
  dofName: __t.string(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
});
export type TwinDofLink = __Infer<typeof TwinDofLink>;

export const TwinGeometryBinding = __t.object("TwinGeometryBinding", {
  bindingId: __t.u64(),
  twinId: __t.string(),
  get kind() {
    return GeometryBindingKind;
  },
  enabled: __t.bool(),
  createdAt: __t.timestamp(),
});
export type TwinGeometryBinding = __Infer<typeof TwinGeometryBinding>;

export const TwinGraphData = __t.object("TwinGraphData", {
  get twin() {
    return DigitalTwinData;
  },
  get metadata() {
    return __t.option(TurboTwinMetadataData);
  },
  get visualAsset() {
    return __t.option(VisualAssetData);
  },
  get ueClass() {
    return __t.option(UeClassData);
  },
  get components() {
    return __t.array(TwinComponentData);
  },
  get properties() {
    return __t.array(TwinPropertyData);
  },
  get relationships() {
    return __t.array(TwinRelationshipData);
  },
  get telemetryLinks() {
    return __t.array(TelemetryLinkData);
  },
});
export type TwinGraphData = __Infer<typeof TwinGraphData>;

export const TwinLocationReference = __t.object("TwinLocationReference", {
  twinId: __t.string(),
});
export type TwinLocationReference = __Infer<typeof TwinLocationReference>;

export const TwinPosition = __t.object("TwinPosition", {
  twinId: __t.string(),
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
  yaw: __t.f32(),
  pitch: __t.f32(),
  roll: __t.f32(),
});
export type TwinPosition = __Infer<typeof TwinPosition>;

export const TwinProperty = __t.object("TwinProperty", {
  propertyId: __t.u64(),
  twinId: __t.string(),
  name: __t.string(),
  dtdlPropertyId: __t.u64(),
  componentInstanceId: __t.option(__t.u64()),
  relationshipInstanceId: __t.option(__t.u64()),
});
export type TwinProperty = __Infer<typeof TwinProperty>;

export const TwinPropertyData = __t.object("TwinPropertyData", {
  twinId: __t.string(),
  name: __t.string(),
  dtdlPropertyId: __t.u64(),
  get value() {
    return PropertyValue;
  },
});
export type TwinPropertyData = __Infer<typeof TwinPropertyData>;

export const TwinRelationshipData = __t.object("TwinRelationshipData", {
  sourceTwinId: __t.string(),
  targetTwinId: __t.string(),
  name: __t.string(),
  get properties() {
    return __t.array(RelationshipPropertyValueData);
  },
});
export type TwinRelationshipData = __Infer<typeof TwinRelationshipData>;

export const TwinRelationshipInstance = __t.object("TwinRelationshipInstance", {
  relationshipId: __t.u64(),
  sourceTwinId: __t.string(),
  targetTwinId: __t.string(),
  name: __t.string(),
  createdDateTime: __t.timestamp(),
});
export type TwinRelationshipInstance = __Infer<typeof TwinRelationshipInstance>;

export const TwinTelemetryLink = __t.object("TwinTelemetryLink", {
  linkId: __t.u64(),
  twinId: __t.string(),
  streamName: __t.string(),
  telemetryName: __t.string(),
  dtdlTelemetryId: __t.u64(),
  componentInstanceId: __t.option(__t.u64()),
});
export type TwinTelemetryLink = __Infer<typeof TwinTelemetryLink>;

export const TwinUeClass = __t.object("TwinUeClass", {
  twinId: __t.string(),
  classPath: __t.string(),
});
export type TwinUeClass = __Infer<typeof TwinUeClass>;

export const TwinWithMetadataCreationData = __t.object("TwinWithMetadataCreationData", {
  get twinData() {
    return TwinCreationData;
  },
  get metadata() {
    return TurboTwinMetadataData;
  },
});
export type TwinWithMetadataCreationData = __Infer<typeof TwinWithMetadataCreationData>;

export const UeClassData = __t.object("UeClassData", {
  classPath: __t.string(),
});
export type UeClassData = __Infer<typeof UeClassData>;

export const UeProjectConfig = __t.object("UeProjectConfig", {
  configId: __t.u32(),
  twinElevationOffsetM: __t.option(__t.f64()),
  sceneYawOffsetDeg: __t.option(__t.f64()),
  autoTeleportPlayerToProjectOrigin: __t.option(__t.bool()),
  clampDynamicTwinsToTerrain: __t.option(__t.bool()),
  clampStaticTwinsToTerrain: __t.option(__t.bool()),
});
export type UeProjectConfig = __Infer<typeof UeProjectConfig>;

// The tagged union or sum type for the algebraic type `UndoAssetBinding`.
export const UndoAssetBinding = __t.enum("UndoAssetBinding", {
  get Asset() {
    return __t.option(UndoTwinAssetBinding);
  },
  UeClass: __t.option(__t.string()),
  MeshSection: __t.option(__t.string()),
  get Geometry() {
    return UndoGeometryBinding;
  },
});
export type UndoAssetBinding = __Infer<typeof UndoAssetBinding>;

export const UndoDofBinding = __t.object("UndoDofBinding", {
  sourceKind: __t.string(),
  sourceName: __t.string(),
  constantValue: __t.f64(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
  transitionSeconds: __t.f64(),
  idleTimeoutSeconds: __t.f64(),
});
export type UndoDofBinding = __Infer<typeof UndoDofBinding>;

export const UndoDofLink = __t.object("UndoDofLink", {
  streamName: __t.string(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
});
export type UndoDofLink = __Infer<typeof UndoDofLink>;

export const UndoDofWiring = __t.object("UndoDofWiring", {
  name: __t.string(),
  get binding() {
    return __t.option(UndoDofBinding);
  },
  get link() {
    return __t.option(UndoDofLink);
  },
});
export type UndoDofWiring = __Infer<typeof UndoDofWiring>;

export const UndoGeometryBinding = __t.object("UndoGeometryBinding", {
  bindingId: __t.u64(),
  get before() {
    return __t.option(UndoGeometryBindingRow);
  },
});
export type UndoGeometryBinding = __Infer<typeof UndoGeometryBinding>;

export const UndoGeometryBindingRow = __t.object("UndoGeometryBindingRow", {
  get kind() {
    return GeometryBindingKind;
  },
  enabled: __t.bool(),
  createdAt: __t.timestamp(),
});
export type UndoGeometryBindingRow = __Infer<typeof UndoGeometryBindingRow>;

export const UndoLocation = __t.object("UndoLocation", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
});
export type UndoLocation = __Infer<typeof UndoLocation>;

export const UndoLocationStream = __t.object("UndoLocationStream", {
  streamName: __t.option(__t.string()),
});
export type UndoLocationStream = __Infer<typeof UndoLocationStream>;

export const UndoOrientation = __t.object("UndoOrientation", {
  yaw: __t.f32(),
  pitch: __t.f32(),
  roll: __t.f32(),
});
export type UndoOrientation = __Infer<typeof UndoOrientation>;

// The tagged union or sum type for the algebraic type `UndoPayload`.
export const UndoPayload = __t.enum("UndoPayload", {
  None: __t.unit(),
  get Location() {
    return UndoLocation;
  },
  get Orientation() {
    return UndoOrientation;
  },
  get Property() {
    return UndoProperty;
  },
  get PropertyAbsent() {
    return UndoPropertyAbsent;
  },
  get PropertyPrimitive() {
    return UndoPropertyPrimitive;
  },
  get DofWiring() {
    return UndoDofWiring;
  },
  get TelemetryLinks() {
    return UndoTelemetryLinks;
  },
  get LocationStream() {
    return UndoLocationStream;
  },
  get Relationship() {
    return UndoRelationship;
  },
  get AssetBinding() {
    return UndoAssetBinding;
  },
  TwinRestore: __t.unit(),
});
export type UndoPayload = __Infer<typeof UndoPayload>;

export const UndoProperty = __t.object("UndoProperty", {
  propertyName: __t.string(),
  get value() {
    return ComplexValue;
  },
});
export type UndoProperty = __Infer<typeof UndoProperty>;

export const UndoPropertyAbsent = __t.object("UndoPropertyAbsent", {
  propertyName: __t.string(),
});
export type UndoPropertyAbsent = __Infer<typeof UndoPropertyAbsent>;

export const UndoPropertyPrimitive = __t.object("UndoPropertyPrimitive", {
  propertyName: __t.string(),
  get value() {
    return PrimitiveValue;
  },
});
export type UndoPropertyPrimitive = __Infer<typeof UndoPropertyPrimitive>;

export const UndoRelationship = __t.object("UndoRelationship", {
  relationshipName: __t.string(),
  get before() {
    return __t.option(UndoRelationshipInstance);
  },
  newestRelationshipId: __t.u64(),
});
export type UndoRelationship = __Infer<typeof UndoRelationship>;

export const UndoRelationshipInstance = __t.object("UndoRelationshipInstance", {
  targetTwinId: __t.string(),
  get properties() {
    return __t.array(RelationshipPropertyValueData);
  },
  relationshipId: __t.u64(),
});
export type UndoRelationshipInstance = __Infer<typeof UndoRelationshipInstance>;

export const UndoTelemetryLink = __t.object("UndoTelemetryLink", {
  linkId: __t.u64(),
  streamName: __t.string(),
  componentInstanceId: __t.option(__t.u64()),
});
export type UndoTelemetryLink = __Infer<typeof UndoTelemetryLink>;

export const UndoTelemetryLinks = __t.object("UndoTelemetryLinks", {
  name: __t.string(),
  get links() {
    return __t.array(UndoTelemetryLink);
  },
  newestLinkId: __t.u64(),
});
export type UndoTelemetryLinks = __Infer<typeof UndoTelemetryLinks>;

export const UndoTwinAssetBinding = __t.object("UndoTwinAssetBinding", {
  assetPath: __t.string(),
  get assetSource() {
    return VisualAssetSource;
  },
  assetModuleAssetId: __t.option(__t.u64()),
});
export type UndoTwinAssetBinding = __Infer<typeof UndoTwinAssetBinding>;

export const Unit = __t.object("Unit", {});
export type Unit = __Infer<typeof Unit>;

export const VisualAssetData = __t.object("VisualAssetData", {
  assetPath: __t.string(),
  get assetTypes() {
    return __t.array(VisualAssetFormat);
  },
  get assetSource() {
    return VisualAssetSource;
  },
});
export type VisualAssetData = __Infer<typeof VisualAssetData>;

export const VisualAssetFormat = __t.object("VisualAssetFormat", {
  format: __t.string(),
  scaleFactor: __t.f64(),
});
export type VisualAssetFormat = __Infer<typeof VisualAssetFormat>;

// The tagged union or sum type for the algebraic type `VisualAssetSource`.
export const VisualAssetSource = __t.enum("VisualAssetSource", {
  Disk: __t.unit(),
  AssetModule: __t.unit(),
});
export type VisualAssetSource = __Infer<typeof VisualAssetSource>;

